/**
 * Remix theme color settings saved on Website → Brand Styling.
 * Matches "Your Brand" / "Your Brand Dark" presets in remix flows.
 */
export function brandRemixLightColorSettings(data) {
  const vibrant = data?.brand_color_vibrant || "#0D42E4";
  const light = data?.brand_color_light || "#ffffff";
  const bg =
    data?.brand_remix_light_background_color?.toString?.().trim() || light;
  return {
    "heading-font-color":
      data?.brand_remix_light_heading_font_color || "#000000",
    "paragraph-font-color":
      data?.brand_remix_light_paragraph_font_color || "#000000",
    "button-color": data?.brand_remix_light_button_color || vibrant,
    "button-text-color":
      data?.brand_remix_light_button_text_color || "#ffffff",
    "accent-color": data?.brand_remix_light_accent_color || vibrant,
    "background-color": bg,
  };
}

export function brandRemixDarkColorSettings(data) {
  const vibrant = data?.brand_color_vibrant || "#0D42E4";
  const dark = data?.brand_color_dark || "#000000";
  const bg =
    data?.brand_remix_dark_background_color?.toString?.().trim() || dark;
  return {
    "heading-font-color":
      data?.brand_remix_dark_heading_font_color || "#ffffff",
    "paragraph-font-color":
      data?.brand_remix_dark_paragraph_font_color || "#ffffff",
    "button-color": data?.brand_remix_dark_button_color || vibrant,
    "button-text-color":
      data?.brand_remix_dark_button_text_color || "#ffffff",
    "accent-color": data?.brand_remix_dark_accent_color || vibrant,
    "background-color": bg,
  };
}
